import { EKwikUIInputPhoneSize } from "./input-phone.definitions";

export const DEFAULT_VALUES = {
  countryCode: "",
  disabled: false,
  focus: false,
  formControlName: "form_control_input_phone",
  hintContent: "",
  icon: "",
  id: "input_phone",
  invalid: false,
  isShowLabelOutside: false,
  label: "Input Phone",
  phoneMaskAfterCountryCode: "####-######",
  placeholder: "Please enter phone number",
  postfix: "",
  prefix: "",
  removeCountryCodeFromValue: true,
  size: EKwikUIInputPhoneSize.L
};

export const VALIDATE_KEY_VALUES = {
  countryCode: true,
  disabled: true,
  focus: true,
  formControlName: true,
  hintContent: true,
  icon: true,
  id: true,
  invalid: true,
  isShowLabelOutside: true,
  label: true,
  phoneMaskAfterCountryCode: true,
  placeholder: true,
  postfix: true,
  prefix: true,
  removeCountryCodeFromValue: true,
  size: true
};
